const { IS_CAMPER } = require('./system');

const CAMPER_GTM_ID = 'GTM-TTHX9KP';
const NNORMAL_GTM_ID = 'GTM-KHCX5VN';
const GMT_ID = IS_CAMPER ? CAMPER_GTM_ID : NNORMAL_GTM_ID;

module.exports = { GMT_ID };
